import * as React from "react";
import { useEffect } from "react";
import { useCookies } from "react-cookie";

const CookieBanner = () => {
  const [cookies, setCookie] = useCookies(["cookie-disclaimer"]);

  useEffect(() => {
    if (!cookies["cookie-disclaimer"]) {
      // Add the CSS link for Clarip's cookie consent
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.type = "text/css";
      link.href = "//cdn.clarip.com/purdue/cookieconsent/assets/css/cookieconsent.min.css";
      document.head.appendChild(link);

      // Add the Clarip script
      const script = document.createElement("script");
      script.src = "//cdn.clarip.com/purdue/cookieconsent/assets/js/cookieconsent.min.js";
      document.body.appendChild(script);

      // Add the script with Clarip configuration
      const configScript = document.createElement("script");
      configScript.innerHTML = `
        var claripCdnHost = "cdn.clarip.com";
        var claripClientName = "purdue";
        var claripCookieConsentHost = "purdue.clarip.com";
        var claripCookieManagerIdentifier = "2333f7000deaadcb5df9";
      `;
      document.body.appendChild(configScript);

      // Add the Clarip cookie manager script
      const cookieManagerScript = document.createElement("script");
      cookieManagerScript.src = "//cdn.clarip.com/purdue/cookieconsent/assets/js/clarip-cookie-manager.min.js";
      document.body.appendChild(cookieManagerScript);

      // Function to handle OK button click
      window.handleCookieConsent = () => {
        const expiryDate = new Date();
        expiryDate.setFullYear(expiryDate.getFullYear() + 1);
        setCookie("cookie-disclaimer", "visited", { path: "/", expires: expiryDate });
      };

      // Inject function call into Clarip script
      const consentScript = document.createElement("script");
      consentScript.innerHTML = `
        document.addEventListener('claripConsentGiven', function() {
          window.handleCookieConsent();
        });
      `;
      document.body.appendChild(consentScript);

      // Clean up the scripts and link when the component unmounts
      return () => {
        document.head.removeChild(link);
        document.body.removeChild(script);
        document.body.removeChild(configScript);
        document.body.removeChild(cookieManagerScript);
        document.body.removeChild(consentScript);
        delete window.handleCookieConsent;
      };
    }
  }, [cookies, setCookie]);

  return null;
};

export default CookieBanner;
